import React from 'react';

export type AlertType = 'info' | 'warning' | 'danger' | 'success';

interface AlertBlockProps {
  type: AlertType;
  icon?: string;
  heading?: string;
  onDismiss?: () => void;
  children?: React.ReactNode;
  testId?: string;
}

export function AlertBlock({ type, icon, heading, onDismiss, children, testId }: AlertBlockProps) {
  return (
    <div className={`alert alert-${type} alert-block`} data-testid={testId}>
      {onDismiss && (
        <button type="button" className="close" aria-label="Dismiss" onClick={onDismiss} data-testid="alert-dismiss-btn">
          <span aria-hidden="true">&times;</span>
        </button>
      )}
      {icon && <i className={`${icon} pull-left`} style={{ marginRight: 8 }} aria-hidden="true"></i>}
      {heading && <h4>{heading}</h4>}
      {children}
    </div>
  );
}
